document.addEventListener('DOMContentLoaded', function () {
    if (window.document.body.clientWidth > 768) {
        setTimeout(setupSticky, 100);
    }

    if (isQuoteReady()) submitQuote(); else showQuoteForm();
});

function setupSticky() {
    var listingRight = $('#listingRight');
    var listingLeft = $('#listingLeft');
    listingRight.css("height", listingLeft.height());
}

function readMore(elementID) {
    var element = $('#' + elementID);
    element.addClass("expanded");
    setupSticky();
}

function scrollTo(element, offset = 0) {
    $('html, body').animate({
        scrollTop: ($("#" + element).first().offset().top + offset)
    }, 300);
}


function openPhotoSwipe(index) {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    // build items array

    // define options (if needed)
    var options = {
        // optionName: 'option value'
        // for example:
        index: index // start at first slide
    };

    // Initializes and opens PhotoSwipe
    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, photoItems, options);
    gallery.init();
}


window.addEventListener('scroll', function (ev) {

    var listingReview = $('#listingReview');
    var scrollTop = $(window).scrollTop();//,
    // elementOffset = priceBreakdown.offset().top,
    // distance = (elementOffset - scrollTop);
    if (scrollTop > 20) {
        if (!listingReview.hasClass("fade-in")) {
            listingReview.addClass("fade-in");
        }
    } else {
        listingReview.removeClass("fade-in");
    }

//    if (distance < 40) {
//        if(!priceBreakdown.hasClass("stick"))
//            priceBreakdown.addClass("stick");

//        let parent = document.querySelector('.stick').parentElement;

//        while (parent) {
//            const hasOverflow = getComputedStyle(parent).overflow;
//            if (hasOverflow !== 'visible') {
//                console.log(hasOverflow, parent);
//            }
//            parent = parent.parentElement;
//        }
//    }
//    else if (priceBreakdown.hasClass("stick")) {
//        //console.log('yes');
////        priceBreakdown.removeClass("stick");
//    }
});

function isQuoteReady() {
    var dateRange = $("#searchCI");
    var guests = $("#searchGuests");

    if (dateRange.val() && guests.val()) {
        return true;
    } else {
        return false;
    }
}

function submitQuote() {
    var rentalID = $('#pnlQuote').data('listing-id'); 

    $('#noteInsufficient').hide();
    $('#noteError').hide();
    $('#noteNA').hide();
    $('#btnQuote').hide();
    $("#noteProcessing").show();
    
    if (isQuoteReady()) { 
        $('#listingDates').hide();
        var guests = $("#searchGuests").val();
        var dates = dateSplitter("searchCI");
        var ciDate = dates[0];
        var coDate = dates[1];
 
        processQuote(ciDate, coDate, guests, rentalID, false);
    } else {
        $('#noteInsufficient').show();
        $("#noteProcessing").hide();
        showQuoteForm(); 
    }

}

function showQuoteForm() {
    var pnlQuote = $("#pnlQuote");
    var pnlReserve = $("#pnlReserve");
    pnlQuote.show();
    pnlReserve.hide();
    $('#btnQuote').show();
    $('#listingDates').show();
}

function showReserveForm() {
    var pnlQuote = $("#pnlQuote");
    var pnlReserve = $("#pnlReserve");
    pnlQuote.hide();
    pnlReserve.show();
}

function processQuote(startDate, endDate, guests, unitID, scroll) {
    const url = `/api/quote/${unitID}?checkin=${startDate}&checkout=${endDate}&guests=${guests}`;

    $.getJSON(url).done(function (data) {
        finishQuote(data);
    }).fail(function () {
        $('#noteError').show();
        showQuoteForm();
    }).always(function () {
        $("#noteProcessing").hide();
    });
}

function addQuoteRow(desc, amount, last = false) {
    return `<div class='d-flex mb-2 ${last ? 'h2' : ''}'>
                <div class="label">${desc}</div>
                <div class="cost">${getCurrency(amount)}</div>
            </div>`; 
}

function formatNight(str) {
    //1 Night @ $431.00 (3/22/2021 - 3/23/2021)
    var tryA = str.split(" @ ");
    if (tryA.length == 1) {
        return str;
    } else {
        var tryB = tryA[1].split(" (");
        if (tryB.length == 1) {
            return str;
        } else {
            var tryC = tryB[1].replace(")", "").split(" - ");
            if (tryC.length == 1) {
                return str;
            } else {
                var night = tryA[0];
                var price = tryB[0];
                var ciDate = tryC[0];
                var coDate = tryC[1];

                const dateCI = new Date(ciDate);
                const dateCO = new Date(coDate);

                return dateCI.getMonth() + "/" + dateCI.getDay() + " to " + dateCO.getMonth() + "/" + dateCO.getDay() + "/" + dateCO.getYear();
            }
        }
    }
}

var quoteTry = 0;

function finishQuote(data) {
    if (data.isValid = "true") {
        if (data.lineItems.length > 0) {
            var quoteDailyRate = $('#quoteDailyRate');
            var mobileDailyRate = $('#mobileDailyRate');
            var quoteDates = $('#quoteDates');
            var mobileDates = $('#mobileDates');
            var quoteTax = $('#quoteTax');
            var quoteTotal = $('#quoteTotal');
            var guests = $("#searchGuests");

            var dataCheckIn = data.checkInDay.replace("T00:00:00", "");
            var dataCheckOut = data.checkOutDay.replace("T00:00:00", "");

            quoteDailyRate.html(getCurrency(data.averageDailyRate));
            mobileDailyRate.html(getCurrency(data.averageDailyRate));

            quoteDates.html(data.dateRange + " (" + guests.val() + " guests)");
            mobileDates.html(data.dateRangeShort);

            quoteTotal.html(data.total);

            quoteTax.html(data.tax);

            var lineItems = "";
            $("#quoteBreakdown").html("");
            $("#quoteBreakdownClean").html("");
            $("#quoteBreakdownSimple").html("");
            
            lineItems = ""; 
            
            lineItems += data.lineItems.map((item) => addQuoteRow(item.description, item.amount));

            lineItems += addQuoteRow("Total", data.total, true);

            $("#quoteBreakdownSimple").html(lineItems);

            //}

            $("#btnReserve").attr("href", data.bookingUrl);

            showReserveForm();
        } else {
            $('#noteNA').html(data.message);
            $('#noteNA').show();
            showQuoteForm();
        }
    } else {
        //$("#bookingNotes").html("<div class='note mts'><i class='fa fa-exclamation-triangle'></i><div class='text'>" + data.message + " Please first click the day you plan to check-in. Then click the day you plan to Check-out." + "</div></div>");
        //$("#bookingList").html("");//.html("Unable to retrieve pricing data");
        //$("#bookingOptions").html("");
        //$("#bookingNow").addClass("hide");
        //$("#quoteRestrictions").addClass("hide");
        //$(".quoteHeader", "#bookingResult").addClass("hide");
        //$("#bookingLoader").addClass("hide");
        //$("#bookingResult").fadeIn(300);
        $('#noteError').show();
    }
    //setRate(data.rentalID, Math.round(data.averageDailyRate));

}
